import OpenGraphModel from '../../../../model/openGraph';
import Loading from './../misc/Loading';
import OpenGraphComponent from './OpenGraph';
import update from 'immutability-helper';
import React from 'react';
import ValidationError from '../../../../model/error/ValidationError';
import withRouter from '/src/components/misc/withRouter';
import modelModel from '../../../../model/model';
import campaignModel from '../../../../model/campaign';
import articleModel from '../../../../model/article';
import makeModel from '../../../../model/makes';

const errorToMessage = (error) => {
  console.error(error);
  if (error instanceof ValidationError) {
    return 'OpenGraph validerer ikke og kan dermed ikke publiseres. Sjekk at alle påkrevede felter er fylt ut med gyldige verdier og prøv igjen.';
  }

  return 'En ukjent feil inntraff ved behandling av openGraph og handlingen kunne dermed ikke fullføres.';
};

class OpenGraphContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opengraph: null,
      newTypeData: {},
      modified: false,
      working: false,
      error: null
    };

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleUnarchive = this.handleUnarchive.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.opengraphId) {
      OpenGraphModel.getById(this.props.match.params.opengraphId, 1).then((opengraph) => {
        document.title = `Admin - Opengraph - ${opengraph.name}`;
        this.setState({
          opengraph: opengraph
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    } else {
      let mode;
      let typePromise;

      // Map admin types to contentful OG mode names
      switch (this.props.match.params.type) {
        case 'campaign':
          mode = 'kampanjer';
          typePromise = campaignModel.getById(this.props.match.params.targetId, 0);
          break;
        case 'model':
          mode = 'modeller';
          typePromise = modelModel.getById(this.props.match.params.targetId, 0);
          break;
        case 'article':
          mode = 'artikler';
          typePromise = articleModel.getById(this.props.match.params.targetId, 0);
          break;
        default:
          // Use global default for others
          mode = '';
          // Any non mode URL tot his component should be a make
          typePromise = makeModel.getById(this.props.match.params.makeId, 0);
      }

      Promise.all([
        OpenGraphModel.getModeDefaults(mode, this.props.match.params.makeId),
        typePromise
      ]).then(([opengraphs, typeData]) => {
        const newOpenGraph = OpenGraphModel.createEmpty(this.props.match.params.makeId, this.props.match.params.targetId);

        // Set the default metadata as default on this new one
        if (opengraphs && opengraphs.length) {
          newOpenGraph.metadata = opengraphs[0].metadata;
        }

        this.setState({
          opengraph: newOpenGraph,
          newTypeData: typeData
        });
      }).catch((e) => {
        this.setState({
          error: errorToMessage(e),
          working: false
        });
      });
    }
  }

  handleSave() {
    this.setState({
      error: null,
      working: true,
      modified: false
    });

    const isCreate = !this.state.opengraph.id;

    OpenGraphModel.save(this.state.opengraph, 1).then((opengraph) => {
      this.setState({
        working: false,
        opengraph: opengraph
      });

      const typePart = this.props.match.params.type ? `${this.props.match.params.type}/` : '';

      if (isCreate) {
        this.props.history.replace(`/opengraph/${typePart}${opengraph.id}`);
      }
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handlePublish() {
    this.setState({
      working: true
    });
    OpenGraphModel.publish(this.state.opengraph.id, 1).then((opengraph) => {
      this.setState({
        working: false,
        opengraph: opengraph
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnpublish() {
    this.setState({
      working: true
    });
    OpenGraphModel.unpublish(this.state.opengraph.id, 1).then((opengraph) => {
      this.setState({
        working: false,
        opengraph: opengraph
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleArchive() {
    this.setState({
      working: true
    });
    OpenGraphModel.archive(this.state.opengraph.id, 1).then((opengraph) => {
      this.setState({
        working: false,
        opengraph: opengraph
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleUnarchive() {
    this.setState({
      working: true
    });
    OpenGraphModel.unarchive(this.state.opengraph.id, 1).then((opengraph) => {
      this.setState({
        working: false,
        opengraph: opengraph
      });
    }).catch((e) => {
      this.setState({
        error: errorToMessage(e),
        working: false
      });
    });
  }

  handleChange(props) {
    const state = update(props, {
      modified: {
        $set: true
      }
    });

    this.setState(state);
  }

  render() {
    if (!this.state.opengraph) {
      return <Loading title="OpenGraph" text="Laster..." />;
    }

    return (
      <OpenGraphComponent
        opengraph={this.state.opengraph}
        newTypeData={this.state.newTypeData}
        targetId={this.props.match.params.targetId}
        type={this.props.match.params.type}
        modified={this.state.modified}
        working={this.state.working}
        error={this.state.error}
        onChange={this.handleChange}
        onSave={this.handleSave}
        onPublish={this.handlePublish}
        onUnpublish={this.handleUnpublish}
        onArchive={this.handleArchive}
        onUnarchive={this.handleUnarchive}
      />
    );
  }
}

OpenGraphContainer.defaultProps = {
  id: null
};

export default withRouter(OpenGraphContainer);
